
export const SITE_URL = "https://www.primerodentalclinic.com";
export const SITE_NAME = "Primero Dental Clinic";
export const CLINIC_ID = `${SITE_URL}/#clinic`;
export const TWITTER_HANDLE = "@PrimeroClinic";
// Stopgap until a dedicated 1200x630 branded OG image is provided.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/clinic/2026-01-29.webp`;

/**
 * Canonical path form for this deployment.
 *
 * vercel.json sets `"trailingSlash": false`, so Vercel answers a request for
 * "/contact/" with a 308 redirect to "/contact". A canonical (or sitemap <loc>,
 * or og:url) that carries a trailing slash therefore points at a URL that
 * redirects rather than at the URL that actually serves the page — a
 * self-inflicted canonical/redirect mismatch. Everything that emits a URL goes
 * through here so the whole site agrees on one form: no trailing slash, except
 * the root which is "/" by definition.
 */
export function canonicalPath(path: string) {
  const withLeading = path.startsWith("/") ? path : `/${path}`;
  const stripped = withLeading.replace(/\/+$/, "");
  return stripped === "" ? "/" : stripped;
}

export function absoluteUrl(path: string) {
  const p = canonicalPath(path);
  return p === "/" ? `${SITE_URL}/` : `${SITE_URL}${p}`;
}

export function buildServiceSchema(opts: {
  name: string;
  description: string;
  serviceType: string;
  url: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: opts.name,
    serviceType: opts.serviceType,
    description: opts.description,
    url: opts.url,
    provider: { "@id": CLINIC_ID },
  };
}

/*
 * There is deliberately no INDEXABLE_ROUTES table here any more.
 *
 * Two previous versions of it were both drift hazards: one was regex-parsed out
 * of this file's own source text by the sitemap script (so it broke the moment
 * the array stopped being a literal of one exact shape), and one lived in a
 * src/data/routes.json mirror of the router that had to be hand-updated.
 *
 * scripts/generate-sitemap.mjs now derives the URL set from the build output
 * itself and asserts en/ar parity, which cannot fall out of sync with the router
 * and catches a whole bug class the old table could not. The router's own source
 * of truth for which pages exist is the content registries under src/content/.
 */
